import SHWFTrackDrawer from './src/drawer.vue';
/* istanbul ignore next */
SHWFTrackDrawer.install = function(Vue) {
  Vue.component('sh-wf-track-drawer', SHWFTrackDrawer);
};
export default SHWFTrackDrawer;


// WEBPACK FOOTER //
// ./src/components/base/view/wf/exec/cmps/track/drawer/index.js